import DoubleCharts from '@op/pages/CustomizedReports/WeeklyReport/Overview/DoubleCharts';
import { DetailConfigType } from '../types';

export const WeeklyReportOverview: DetailConfigType = {
  Component: DoubleCharts,
  defaultProps: {},
  title: 'Overview',
  detailPageOptions: {
    showViewMore: false
  }
};
